export const backendHost = '';
// export const backendHost = 'http://localhost:5000';

export const backendApi = backendHost + '/api';
export const contactTokenKey = "cFGbSbk6weHOyDShKh19XW9D0FKphP4uaIIKoAGFCxymZbDl08UDHsvgR2isibJ5";